<template>
  <div class="mobile-table-content">
    <div class="table-title">
      <div class="title-left"><i class="el-icon-s-management" />结清信息</div>
      <div class="title-right"></div>
    </div>
    <!-- 结清信息 -->
    <div class="list-content">
      <CommonDetail :listConfig="listConfig" :listData="formData">
        <template v-slot:applyOptionList>
          <div :class="['info-right']">
            <div v-for="(item) in formData.applyOptionList" :key="item">
              {{ item }}
            </div>
          </div>
        </template>
      </CommonDetail>
    </div>
    <template>
      <div class="table-title">
        <div class="title-left">
          <i class="el-icon-s-management" />保理首付款及使用费信息
        </div>
        <div class="title-right"></div>
      </div>
      <TableCustom
        :readOnly="true"
        :tableParams="tableParams"
        :tableData="rentPlanCollections"
        :sumProperty='[
          "collectionPrincipal",
          "surplusPrincipal",
          "collectionInterest",
          "surplusInterest",
        ]'
        style="margin-left: 10px"
      >
      </TableCustom>
    </template>
    <template>
      <div class="table-title">
        <div class="title-left">
          <i class="el-icon-s-management" />宽限期使用费及罚息信息
        </div>
        <div class="title-right"></div>
      </div>
      <TableCustom
        :readOnly="true"
        :tableParams="tableParamsGracePeriod"
        :tableData="overdueInterests"
        style="margin-left: 10px"
      >
      </TableCustom>
      <div class="list-content">
        <CommonDetail :listConfig="listConfigGracePeriod" :listData="formData">
        </CommonDetail>
      </div>
    </template>
    <template>
      <div class="table-title">
        <div class="title-left">
          <i class="el-icon-s-management" />保证金信息
        </div>
        <div class="title-right"></div>
      </div>
      <TableCustom
        :readOnly="true"
        :tableParams="tableParamsMargin"
        :tableData="deposits"
        style="margin-left: 10px"
      >
      </TableCustom>
    </template>
    <template>
      <div class="table-title">
        <div class="title-left"><i class="el-icon-s-management" />结清合计</div>
        <div class="title-right"></div>
      </div>
      <!-- 结清合计 -->
      <div class="list-content">
        <CommonDetail :listConfig="listConfigMargin" :listData="formData">
        </CommonDetail>
      </div>
    </template>
  </div>
</template>
<script>
import CommonDetail from "@/components/workflowComponents/mobile/commonDetail";
import TableCustom from "@/components/tableCustom/tableCustom";
import { mapGetters } from "vuex";
import * as api from "@/api/factoring/factoring";
import SelectInput from "@/components/commonSelect/selectInput";
import SelectDrawer from "@/components/workflowComponents/mobile/selectDrawer";
import workFlow from "@/mixins/workFlow";
import util from "@/mixins/util";
import { floatAdd } from "@/util/util";
export default {
  name: "mobileInvestmentLoanManagement",
  mixins: [workFlow, util],
  data() {
    return {
      rentPlanCollections:[],
      overdueInterests:[],
      deposits:[],
      tableData: [],
      formOneData: {},
      formTwoData: {},
      listConfig: [
        {
          label: "项目名称",
          prop: "projectName",
        },
        {
          label: "保理合同",
          prop: "contractName",
        },
        {
          label: "合同金额",
          prop: "contractFactoringCredit",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
        },
        {
          label: "卖方（债权人）",
          prop: "sellerCustName",
        },
        {
          label: "保理商",
          prop: "formAccountingEntityStr",
        },
        {
          label: "所属部门",
          prop: "managerDeptName",
        },

        {
          label: "业务主办",
          prop: "managerUserName",
        },
        {
          label: "业务协办",
          prop: "assistUserName",
        },
        {
          label: "申请事项",
          prop: "applyOptionList",
          type: "textarea",
          slot: true,
        },
        {
          label: "备注",
          prop: "remarks",
          type: "textarea",
        },
      ],

      tableParams: {
        index: false,
        indexLabel: "序号",
        align: "center",
        isSummaryMethod:true,
        column: [
          {
            label: "批次",
            prop: "investBatch",
            formatter: (label, value) => {
              return `第${value}批`;
            },
          },
          {
            label: "放款次号",
            prop: "paymentBatch",
            formatter: (label, value) => {
              return `第${value}笔`;
            },
          },
          {
            label: "已还首付款",
            prop: "collectionPrincipal",
            formatter: (label, value) => {
              return this.getMoney(value);
            },
            width:100
          },
          {
            label: "剩余首付款",
            prop: "surplusPrincipal",
            formatter: (label, value) => {
              return this.getMoney(value);
            },
            width:100
          },
          {
            label: "已还使用费",
            prop: "collectionInterest",
            formatter: (label, value) => {
              return this.getMoney(value);
            },
            width:100
          },
          {
            label: "剩余使用费",
            prop: "surplusInterest",
            formatter: (label, value) => {
              return this.getMoney(value);
            },
            width:100
          },
          {
            label: "还款期数",
            prop: "issue",
            formatter: (label, value) => {
              return value + "期";
            },
          },
          {
            label: "已还期数",
            prop: "collectionIssue",
            formatter: (label, value) => {
              return value + "期";
            },
          },
          {
            label: "剩余期数",
            prop: "surplusIssue",
            formatter: (label, value) => {
              return value + "期";
            },
          },
        ],
      },
      tableParamsGracePeriod: {
        index: false,
        indexLabel: "序号",
        align: "center",
        column: [
          {
            label: "批次",
            prop: "batch",
            formatter: (label, value) => {
              return `第${value}批`;
            },
          },
          {
            label: "超期期数",
            prop: "paymentBatch",
            slot: true,
          },
          {
            label: "宽限期天数",
            prop: "gracePeriodDays",
            formatter: (label, value) => {
              return value + "天";
            },
            width:100
          },
          {
            label: "逾期天数",
            prop: "overdueDays",
            formatter: (label, value) => {
              return value + "天";
            },
          },
          {
            label: "宽限期费率",
            prop: "gracePeriodRate",
            formatter: (label, value) => {
              return (Number(value) * 100).toFixed(2) + "%";
            },
            width:100
          },
          {
            label: "逾期利率",
            prop: "overdueInterestRate",
            formatter: (label, value) => {
              return (Number(value) * 100).toFixed(2) + "%";
            },
          },
          {
            label: "本期应收账款",
            prop: "receivableRent",
            formatter: (label, value) => {
              return this.getMoney(value);
            },
            width:120
          },
          {
            label: "超期费用",
            prop: "overdueAmount",
            formatter: (label, value) => {
              return this.getMoney(value);
            },
          },
          {
            label: "罚息状态",
            prop: "paymentStr",
          },
          {
            label: "还款日",
            prop: "rentDate",
          },
        ],
      },
      listConfigGracePeriod: [
        {
          label: "总宽限期使用费",
          prop: "totalExpireAmountStr",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
        },
        {
          label: "总罚息金额",
          prop: "totalOverdueInterestAmountStr",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
        },
        {
          label: "总超期金额",
          prop: "totalOverdueAmountStr",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
        },
        {
          label: "剩余总超期金额",
          prop: "totalSurplusOverdueAmountStr",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
        },
        {
          label: "减免金额",
          prop: "creditAmount",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
        },
        {
          label: "说明",
          prop: "depositDeductionAmountStr",
          type: "textarea",
        },
      ],
      tableParamsMargin: {
        index: false,
        indexLabel: "序号",
        align: "center",
        column: [
          {
            label: "批次",
            prop: "batchStr",
            formatter: (label, value) => {
              return `第${value}批`;
            },
          },
          {
            label: "保证金金额",
            prop: "surplusAmount",
            formatter: (label, value) => {
              return this.getMoney(value);
            },
            width:100
          },
          {
            label: "收取方式",
            prop: "outlayWayStr",
          },
          {
            label: "到期处理方式",
            prop: "expirationTreatmentStr",
             width:120
          },
         
          {
            label: "抵扣金额",
            prop: "deductionAmount",
            formatter: (label, value) => {
              return this.getMoney(value);
            },
          },
          {
            label: "剩余保证金",
            prop: "depositsMoney",
            formatter: (label, value) => {
              return this.getMoney(value);
            },
          },
        ],
      },
      listConfigMargin: [
        {
          label: "剩余保理首付款",
          prop: "totalSurplusPrincipalStr",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
           width:140
        },
        {
          label: "剩余使用费",
          prop: "totalSurplusInterestStr",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
          width:100
        },
        {
          label: "剩余超期费用",
          prop: "surplusOverdueAmountStr",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
           width:120
        },
        {
          label: "应退回保证金",
          prop: "totalSurplusRefundAmountStr",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
          width:120
        },
        {
          label: "其他费用",
          prop: "otherAmount",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },
        },
        {
          label: "备注",
          prop: "finishExplain",
          type: "textarea",
        },
      ],
    };
  },
  components: {
    CommonDetail,
    SelectInput,
    SelectDrawer,
    TableCustom,
  },
  props: {
    listData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    flowData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    listData: {
      handler(newData, oldData) {
        if (newData.id && newData.id != "") {
          this.formData = newData;
          this.selectProjectId = newData.projectInfoId;
          this.selectContractId = newData.conManageId;
          // 申请事项
          if (this.formData.applyItems != "") {
            this.itemOptionArray = newData.applyItems.split(",");
            let applyOption = newData.applyItems.split(",");
            this.formData.applyOptionList = [];
            let applyOptionList = [
              {
                label: "1.保证金退还",
                value: "0",
              },
              {
                label: "2.办理抵、质押手续",
                value: "1",
              },
              {
                label: "3.其它",
                value: "2",
              },
            ];
            applyOption.map((item) => {
              applyOptionList.map((el) => {
                if (item == el.value) {
                  this.formData.applyOptionList.push(el.label);
                }
              });
            });
          }
          // 减免金额
          this.formData.creditAmount = newData.reduceAmount;
          this.formData.creditAmountStr =
            newData.creditAmount && newData.creditAmount != -1
              ? this.getMoney(Number(newData.creditAmount))
              : "";
          // 保证金
          this.formData.deposits = newData.deductions;
          this.queryCompleteDetail(this.$route.params.id);
        }
      },
      immediate: true,
    },
  },
  methods: {
    async dealDetailData(data) {
      this.formData = data;
    },
    async queryCompleteDetail(id) {
      let res = await api.completeDetail({ id });
      if (res.data.code == 200) {
        console.info(res.data.data, "completeDetail");
        let resData = res.data.data;
        // 处理数据
        this.formData.selectProjectId = resData.projectInfoId;
        this.selectProjectId = resData.projectInfoId;

        this.formData.selectContractId = resData.conManageId;
        this.selectContractId = resData.conManageId;

        this.queryContractDetail(this.selectContractId);

        this.$forceUpdate();
      }
    },
    async queryContractDetail(id) {
      let res = await api.contractList({ id });
      let data = res.data.data.records;
      this.setContractInfo(data[0]);
    },
    setContractInfo(data) {
      if (data && JSON.stringify(data) != "{}") {
        // 合同金额
        this.formData.contractId = data.id;
        // 合同名称
        this.formData.contractName = data.contractName;
        // 合同金额
        this.formData.contractFactoringCredit = data.factoringCredit
          ? `${this.getMoney(Number(data.factoringCredit))}`
          : "";
        // 协办
        this.formData.assistUserName = data.assistUserName;
        // 主办
        this.formData.managerUserName = data.managerUserName;
        // 所属部门
        this.formData.managerDeptName = data.managerDeptName;
        // 保理商
        this.formData.formAccountingEntityStr = data.formAccountingEntityStr;
        // 客户名称
        this.formData.sellerCustName = data.sellerCustName;
        // 查询结清前详情
        this.queryBeforeCompleteInfo(data.id);
        this.$forceUpdate();
      } else {
        this.clearData();
      }
    },
    async queryBeforeCompleteInfo(id) {
      let self = this;
      let res = await api.beforeCompleteAddDetail({ id });
      if (res.data.code == 200) {
        this.beforeAddDetail = res.data.data;
        this.rentPlanCollections = res.data.data.rentPlanCollections;
        this.overdueInterests = res.data.data.overdueInterests;
        let deposits = res.data.data.deposits;
        if (this.formData.deductions && this.formData.deductions.length > 0) {
          deposits.map((item) => {
            let depositsOne = self.formData.deductions.filter((i) => {
              return i.depositId == item.id;
            });
            if (depositsOne.length > 0)
              item.deductionAmount = depositsOne[0].deductionAmount;
          });
        }
        this.deposits = deposits;
        // 处理数据
        this.dealData(res.data.data);
      }
    },
    dealData(data) {
      let setData = {
        ...this.formData,
      };
      // 总宽限期使用费
      setData.totalExpireAmount = data.totalExpireAmount;
      setData.totalExpireAmountStr =
        data.totalExpireAmount && data.totalExpireAmount != "-1"
          ? this.getMoney(Number(data.totalExpireAmount))
          : "";
      // 总罚息金额
      setData.totalOverdueInterestAmount = data.totalOverdueInterestAmount;
      setData.totalOverdueInterestAmountStr =
        data.totalOverdueInterestAmount && data.totalOverdueInterestAmount != ""
          ? this.getMoney(Number(data.totalOverdueInterestAmount))
          : "";
      // 总超期金额
      setData.totalOverdueAmount = data.totalOverdueAmount;
      setData.totalOverdueAmountStr =
        data.totalOverdueAmount && data.totalOverdueAmount != "-1"
          ? this.getMoney(Number(data.totalOverdueAmount))
          : "";
      // 剩余总超期金额
      setData.totalSurplusOverdueAmount = data.totalSurplusOverdueAmount;
      setData.totalSurplusOverdueAmountStr =
        data.totalSurplusOverdueAmount && data.totalSurplusOverdueAmount != "-1"
          ? this.getMoney(Number(data.totalSurplusOverdueAmount))
          : "";
      // 减免金额
      // this.formData.creditAmount = data.creditAmount?data.creditAmount:''
      // this.formData.creditAmountStr = data.creditAmount&& data.creditAmount != -1?this.getMoney(Number(data.creditAmount)):''

      // 剩余保理首付款
      setData.totalSurplusPrincipal = data.totalSurplusPrincipal;
      setData.totalSurplusPrincipalStr =
        data.totalSurplusPrincipal && data.totalSurplusPrincipal != -1
          ? this.getMoney(Number(data.totalSurplusPrincipal))
          : "";

      // 剩余使用费
      setData.totalSurplusInterest = data.totalSurplusInterest;
      setData.totalSurplusInterestStr = this.getMoney(
        Number(data.totalSurplusInterest)
      );

      // 剩余超期费用 (剩余总超期金额-减免金额)
      setData.surplusOverdueAmount =
        Number(data.totalSurplusOverdueAmount) -
        (this.formData.creditAmount && this.formData.creditAmount != ""
          ? Number(this.formData.creditAmount)
          : 0);
      setData.surplusOverdueAmountStr =
        this.formData.surplusOverdueAmount &&
        this.formData.surplusOverdueAmount != ""
          ? this.getMoney(Number(this.formData.surplusOverdueAmount))
          : "";

      // 应退回保证金
      setData.totalSurplusRefundAmount = data.totalSurplusRefundAmount;
      setData.totalSurplusRefundAmountStr = this.getMoney(
        Number(data.totalSurplusRefundAmount)
      );

      this.formData = setData;
    },
    setDeposits(row, index, value) {
      if (Number(row.receivedAmount) < Number(row.deductionAmount)) {
        this.deposits[index].deductionAmount = 0;
        this.$set(
          this.deposits[index],
          "depositsMoney",
          Number(row.receivedAmount)
        );
        this.$message.warning("输入的抵扣金额不得大于已收保证金金额");
      } else {
        // let newObj = this.deposits[index]
        // newObj.depositsMoney = Number(row.receivedAmount) - Number(row.deductionAmount)
        // this.deposits[index] = newObj
        // this.deposits[index].depositsMoney = Number(row.receivedAmount) - Number(row.deductionAmount)
        let initData = Number(row.receivedAmount) - Number(row.deductionAmount);
        this.$set(this.deposits[index], "depositsMoney", initData);
      }
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss" scoped>
.mobile-table-content {
  .table-title {
    width: 100%;
    height: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1rem;
    margin-top: 0.2rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    .title-left {
      font-size: .38rem;
      color: #666;
      font-weight: 600;
    }
    .title-right {
      font-size: .38rem;
      color: #ccc;
    }
  }
  .list-content {
    .info-one {
      background-color: #fff;
      border-top: 0.5px solid #f2f2f2;
      border-bottom: 0.5px solid #f2f2f2;
      padding-left: 0.3rem;
      padding-right: 0.3rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 1.2rem;
      padding-top: 0.15rem;
      padding-bottom: 0.15rem;
      .info-left {
        width: 30%;
        color: #999;
        font-size: .38rem;
      }
      .info-right {
        width: 65%;
        font-size: .38rem;
        text-align: right;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        // white-space: nowrap;
      }
    }
  }
  .item-one {
    background-color: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
    width: 100%;
    padding: 0.35rem 0.4rem;
    border-radius: 0.2rem;
    margin-bottom: 0.2rem;
    .item-index {
      font-size: .38rem;
      line-height: 0.7rem;
      color: #999;
      font-weight: 600;
    }
    .item-line {
      font-size: .38rem;
      line-height: 0.55rem;
      color: #999;
      span {
        margin-left: 0.3rem;
      }
    }
    .remark-content {
      font-size: .38rem;
      color: #333;
      line-height: 0.7rem;
    }
  }
}
.info_right_edit {
  color: #409eff !important;
  cursor: pointer !important;
}
</style>